import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { PositionSide } from 'wintrado-api';
export const BuySellIconAlternative = React.memo(({ side, width = 10, height = 10 }) => {
    if (side === PositionSide.BUY) {
        return (_jsx("img", { alt: "buy-icon", style: { width, height, marginRight: 2 }, src: require('../icons/main/buy-small.svg?url') }));
    }
    return (_jsx("img", { alt: "sell-icon", style: { width, height, marginRight: 2 }, src: require('../icons/main/sell-small.svg?url') }));
});
